// extracted by mini-css-extract-plugin
module.exports = {"Component":"Modal_Component__1S4jW","show":"Modal_show__1g0pZ","Modal":"Modal_Modal__32zLH"};